import { useTranslation } from 'react-i18next';

import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';
import { IOption } from 'coreOld/types';
import { getPlural } from 'coreOld/utils';
import { useGetLevels, useGetRequestStatuses } from 'support/hooks';
import { IUpdateRequestForm } from 'support/types';

import { updateRequestSchema } from './updateRequestSchema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: IUpdateRequestForm) => void;
  onRequiredDateChange: (date: string) => void;
  selectedItemsCount: number;
}

const UpdateRequestFormView = ({
  isOpen,
  onClose,
  onSubmit,
  onRequiredDateChange,
  selectedItemsCount,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<IUpdateRequestForm>
      isOpen={isOpen}
      onClose={onClose}
      title={getPlural(t('labelUpdateSupportRequest'), selectedItemsCount > 1)}
      submitBtnLabel={getPlural(t('buttonLabelUpdateSupportRequest'), selectedItemsCount > 1)}
      onSubmit={onSubmit}
      schema={updateRequestSchema()}
    >
      <Field
        name="statusId"
        type={InputType.SELECT}
        label="Status"
        inputProps={{
          useGetOptions: useGetRequestStatuses,
          getValue: (option: IOption) => option.id,
          getLabel: (option: IOption) => option.name,
          placeholder: 'Select Status',
          size: Size.MD,
          isClearable: true,
        }}
      />
      <Field
        name="levelId"
        type={InputType.SELECT}
        label="Level"
        inputProps={{
          useGetOptions: useGetLevels,
          getValue: (option: IOption) => option.id,
          getLabel: (option: IOption) => option.name,
          placeholder: 'Select Level',
          size: Size.MD,
          isClearable: true,
        }}
      />
      <Field
        name="requiredByDate"
        label={t('labelRequestedDate')}
        type={InputType.DATE_INPUT}
        inputProps={{
          size: Size.MD,
          minDate: new Date(),
          onChange: onRequiredDateChange,
        }}
      />
    </Form>
  );
};

export default UpdateRequestFormView;
